import axios from 'axios';
import * as React from 'react';
import { requestContactMessageChannelStats } from '../asyncHelpers/dashboardStatsService';
import { RequestStatus } from '../sic-lib/enums/RequestStatus';
import {
    ContactMessageChannelRequest,
    ContactMessageChannelStats,
} from '../sic-lib/types/ContactMessageChannelStats';
import { useAppDispatch } from '../store/hooks';
import { createToast } from '../store/notify';
import { createErrorToast } from '../utils/notifyHelpers';

/**
 * useAsyncGetContactMessageChannelStats
 *
 * @description
 * React hook providing request state management and cancellation for the
 * requestContactMessageChannelStats HTTP request for the dashboard
 */
export default function useAsyncGetContactMessageChannelStats() {
    const dispatch = useAppDispatch();
    const request_token = axios.CancelToken.source();

    React.useEffect(() => {
        return () => {
            request_token.cancel();
        };
    }, []);

    const [requestStatus, setRequestStatus] = React.useState<RequestStatus>(RequestStatus.none);

    const asyncGetContactMessageChannelStats = async (
        dates: ContactMessageChannelRequest,
    ): Promise<ContactMessageChannelStats | undefined> => {
        try {
            setRequestStatus(RequestStatus.active);

            const { data } = await requestContactMessageChannelStats(dates, request_token.token);
            setRequestStatus(RequestStatus.success);

            return data;
        } catch (error: any) {
            if (!axios.isCancel(error)) {
                /* Notify user of failed http request */
                const toastData = createErrorToast('Error while retrieving dashboard stats');

                dispatch(createToast({ toastData }));

                /* Update state */
                setRequestStatus(RequestStatus.error);
            }
        }
    };

    return {
        requestStatus,
        asyncGetContactMessageChannelStats,
    };
}
